<template>
  <div id="popup" :class="'ol-popup'">
    <a
      href="#"
      id="popup-closer"
      class="ol-popup-closer"
      v-if="mapSetting !== 'gaodemap'"
      @click.prevent="closePopup"
    ></a>
    <div id="popup-content" v-if="currentData">
      <div class="text-content">
        <div class="item">
          <span>裸土编号：</span>
          <span>{{ currentData.gid }}</span>
        </div>
        <div class="item">
          <span>所属区县：</span>
          <span>{{ currentData.district }}</span>
        </div>
        <div class="item">
          <span>地址：</span>
          <span>{{ currentData.address }}</span>
        </div>
        <div class="item">
          <span>裸土状态：</span>
          <span>{{ currentData.status }}</span>
        </div>
        <div class="item">
          <span>类型：</span>
          <span>{{ currentData.type }}</span>
        </div>
        <div class="item">
          <span>图斑面积：</span>
          <span>{{ currentData.area ? Math.round(currentData.area) : "" }}(平方米)</span>
        </div>
        <div class="item" v-if="currentData.actualArea">
          <span>裸土面积：</span>
          <span>{{ currentData.actualArea }}(平方米)</span>
        </div>
        <div class="item" v-if="currentData.actualAreaRatio">
          <span>占比：</span>
          <span>{{ currentData.actualAreaRatio }}</span>
        </div>
        <div class="item">
          <span>最新扫描时间：</span>
          <span>{{ currentData.remoteSenseTime }}</span>
        </div>
        <div class="item" v-if="currentData && currentData.inspectionTime">
          <span>最后巡查时间：</span>
          <span>{{ currentData.inspectionTime }}</span>
        </div>
        <div class="item">
          <span>裸土经纬度：</span>
          <span>{{ currentData.lng }},{{ currentData.lat }}</span>
        </div>
        <div class="drone-section">
          <div class="drone-title">无人机巡查</div>
          <div class="drone-images-container" v-if="currentData.imgList && currentData.imgList.length > 0">
            <div class="drone-images-scroll">
              <div class="drone-image-item" v-for="(img, index) in currentData.imgList" :key="index" @click="previewDroneImg(index)">
                <img :src="getFullImageUrl(img.fileDownload)" alt="无人机图片" />
              </div>
            </div>
          </div>
          <div class="drone-empty" v-else>暂无无人机巡查图片</div>
          <div class="drone-upload">
            <a-upload
              :file-list="droneFileList"
              :before-upload="beforeDroneUpload"
              :remove="handleDroneRemove"
              multiple
              accept="image/*"
            >
              <a-button type="primary" size="small" :loading="droneUploadLoading">
                <a-icon type="upload" />选择图片
              </a-button>
            </a-upload>
            <a-button type="primary" size="small" @click="uploadDroneImages" :loading="droneUploadLoading" style="margin-left: 8px;">
              <a-icon type="cloud-upload" />上传
            </a-button>
          </div>
        </div>
      </div>
    </div>
    <div class="popup-content" v-else-if="thirdData">
      <div class="text-content">
        <div class="item" v-for="item in thirdData" :key="item.thirdColumn">
          <span>{{item['thirdColumnTitle']}}：</span>
          <span>{{ item['thirdColumnValue'] }}</span>
        </div>
        <!-- <div class="item">
          <span>裸土序号：</span>
          <span>{{ thirdData.thirdNo }}</span>
        </div>
        <div class="item">
          <span>所属区县：</span>
          <span>{{ thirdData.thirdDistrict }}</span>
        </div>
        <div class="item">
          <span>裸土面积：</span>
          <span>{{ thirdData.thirdArea }}(公顷)</span>
        </div>
        <div class="item">
          <span>裸土经纬度：</span>
          <span>{{ thirdData.thirdLng }},{{ thirdData.thirdLat }}</span>
        </div>
        <div class="item">
          <span>数据导入时间：</span>
          <span>{{ thirdData.createTime }}</span>
        </div>
        <div class="item">
          <span>来源文件：</span>
          <span>{{ thirdData.title }}</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail, getThirdDetail, uploadDroneImg, baseurl } from '@/api'
import vueSeamlessScroll from 'vue-seamless-scroll'
import PatrolImages from './PatrolImages.vue'
import PatrolInspection from './PatrolInspection.vue'
export default {
  name: 'MapPopup',
  components: {
    vueSeamlessScroll,
    PatrolImages,
    PatrolInspection,
  },
  remoteLayerInfo: {
    deep: true,
    handler() {
      this.changeRemote()
    },
  },
  data() {
    return {
      show: false,
      currentData: null,
      classOption: {
        direction: 3,
      },
      picShow: false,
      patrolInspectionShow: false,
      fileList: [],
      uploadLoading: false,
      thirdData: null,
      thirdDataFlg: false,
      droneFileList: [],
      droneUploadLoading: false,
      baseurl: baseurl,
    }
  },
  props: {
    mapSetting: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    getFullImageUrl(url) {
      if (!url) return ''
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
      }
      return `${this.baseurl}${url}`
    },
    previewImg(index) {
      this.$hevueImgPreview({
        nowImgIndex: index,
        imgList: this.currentData.imgList.map((item) => this.getFullImageUrl(item.fileDownload)),
        multiple: true,
        clickMaskCLose: true,
      })
    },
    previewDroneImg(index) {
      this.$hevueImgPreview({
        nowImgIndex: index,
        imgList: this.currentData.imgList.map((item) => this.getFullImageUrl(item.fileDownload)),
        multiple: true,
        clickMaskCLose: true,
      })
    },
    beforeDroneUpload(file) {
      this.droneFileList = [...this.droneFileList, file]
      return false
    },
    handleDroneRemove(file) {
      const index = this.droneFileList.indexOf(file)
      const newFileList = this.droneFileList.slice()
      newFileList.splice(index, 1)
      this.droneFileList = newFileList
    },
    uploadDroneImages() {
      if (this.droneFileList.length === 0) {
        this.$message.warning('请选择要上传的图片')
        return
      }
      this.droneUploadLoading = true
      const formData = new FormData()
      this.droneFileList.forEach(file => {
        formData.append('files', file)
      })
      formData.append('bareSoilId', this.currentData.gid)
      formData.append('pid', this.currentData.pid || 0)
      formData.append('inspectionDate', new Date().toISOString().split('T')[0])
      
      uploadDroneImg(formData)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('上传成功')
            this.droneFileList = []
            this.showPop(this.currentData.gid, null, null)
          } else {
            this.$message.error(res.data.msg || '上传失败')
          }
        })
        .catch(() => {
          this.$message.error('上传失败')
        })
        .finally(() => {
          this.droneUploadLoading = false
        })
    },
    showPop(currentId, month, year) {
      let params = { gid: currentId, month: month, year: year }
      return getDetail(params)
        .then((res) => {
          const { code, data } = res.data
          if (code === 200) {
            this.currentData = data
            this.show = true
          } else {
            this.currentData = null
          }
        })
        .catch(() => {
          this.currentData = null
        })
    },
    showThirdPop(thirdId, thirdTitle) {
      this.currentData = null
      let params = { thirdId: thirdId, title: thirdTitle }
      return getThirdDetail(params)
        .then((res) => {
          const { code, data } = res
          if (code === 200) {
            let thirdData = data
            thirdData = thirdData.filter(x => x.orderVal !== null)
            thirdData.sort((a, b) => a.orderVal - b.orderVal)
            this.show = true
            this.$nextTick(() => {
              this.thirdData = thirdData
            })
          } else {
            this.thirdData = null
          }
        })
        .catch(() => {
          this.thirdData = null
        })
    },
    showInfo() {
      this.picShow = true
    },
    addPatrolInspection() {
      this.patrolInspectionShow = true
    },
    closePatrolInspection() {
      this.patrolInspectionShow = false
    },
    closePopup() {
      this.$emit('closePopup')
    },
  },
}
</script>

<style scoped lang="less">
.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 364px;
  z-index: 9;
}
.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}
.ol-popup-closer:after {
  content: '✖';
}
.text-content {
  .item {
    padding: 6px 12px;
  }
}
.drone-section {
  margin-top: 10px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 5px;
}
.drone-title {
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 14px;
}
.drone-images-container {
  width: 100%;
  overflow-x: auto;
  margin-bottom: 10px;
}
.drone-images-scroll {
  display: flex;
  gap: 8px;
  padding: 4px 0;
}
.drone-image-item {
  flex: 0 0 calc(50% - 4px);
  height: 80px;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}
.drone-image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.drone-empty {
  text-align: center;
  color: #999;
  padding: 20px 0;
  font-size: 12px;
}
.drone-upload {
  display: flex;
  align-items: center;
}
.warp {
  width: 70px * 4;
  height: 80px;
  padding: 0 12px;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    &.ul-item {
      display: flex;
      .li-item {
        width: 8.2vh;
        height: 5vh;
        margin-right: 0.2vh;
        cursor: pointer;
        border: 2px solid #e0dada;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 8vh;
          height: 4.8vh;
        }
      }
    }
  }
}
.noimg {
  width: 70px * 4;
  height: 80px;
  padding: 0 12px;
  text-align: center;
  line-height: 80px;
}
.pic {
  display: flex;
}
</style>
